import { BookmarkTargetType } from '~/apollo/generated/v3/graphql';
import type {
  FilePartsFragment,
  PicturePartsFragment,
} from '~/apollo/generated/v4/graphql';
import type { TargetBookmarksManagerModalProps } from '~/components/bookmark/TargetBookmarksManagerModal';
import { PictureThumbnailV4 } from '~/components/common/picture-thumbnail-v4';
import type { BookmarkableSOProps } from '~/components/supporting-object/so-item-display-v4';
import type { RefetchQueries } from '~/utils/graphql';

type Picture = PicturePartsFragment & {
  pictureUrl: string;
  thumbnailUrl: string;
  file: FilePartsFragment;
};

export function PanoramaItemDisplayV4({
  pictures,
  bookmarkable,
  refetchQueries,
}: {
  pictures?: Picture[];
  bookmarkable?: BookmarkableSOProps & { parentId: number };
  refetchQueries: RefetchQueries;
}) {
  if (!pictures?.length) return null;

  const bookmarkableProps = (
    picture: Picture,
  ): TargetBookmarksManagerModalProps | undefined => {
    if (!bookmarkable) return undefined;
    return {
      ...bookmarkable,
      targetType: BookmarkTargetType.Picture,
      targetId: parseInt(picture.id),
    };
  };

  return (
    <div className="space-y-2">
      {pictures.map(p => (
        <PictureThumbnailV4
          key={p.id}
          picture={p}
          imgSrc={p.pictureUrl}
          thumbnailImgSrc={p.thumbnailUrl}
          bookmarkable={bookmarkableProps(p)}
          refetchQueries={refetchQueries}
        />
      ))}
    </div>
  );
}
